module.exports = __webpack_public_path__ + "img/fontello.9354499c.svg";